import React from 'react';
export function ProductIntroSection() {
  return <section className="py-16 md:py-24 bg-brand-beige relative overflow-hidden" data-id="element-224">
      <div className="max-w-4xl mx-auto px-5 md:px-8 text-center relative z-10" data-id="element-225">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-dark mb-4" data-id="element-226">
          Apresentando o Protocolo Desincha40+
        </h2>
        <h3 className="text-xl md:text-2xl text-brand-sage-dark font-medium mb-8" data-id="element-227">
          Um plano alimentar simples de 21 dias para mulheres acima dos 40 que
          querem reduzir o inchaço e recuperar a sensação de leveza.
        </h3>

        <p className="text-lg text-brand-text/80 leading-relaxed mb-10 max-w-3xl mx-auto" data-id="element-228">
          O Desincha40+ foi criado para mulheres que sentem que o corpo ficou
          mais sensível depois dos 40. Mulheres que não querem viver de dieta,
          não querem cortar tudo e não querem passar horas na academia.
        </p>

        <div className="bg-white p-8 rounded-2xl shadow-sm border border-brand-sage/30 mb-10" data-id="element-229">
          <p className="text-2xl font-serif text-brand-dark italic" data-id="element-230">
            "Elas só querem abrir o armário, vestir uma roupa e sentir: 'Agora
            sim. Meu corpo voltou a responder.'"
          </p>
        </div>

        <a href="#oferta" className="inline-block bg-brand-dark hover:bg-brand-text text-white font-semibold px-8 py-4 rounded-full text-lg transition-all duration-300 shadow-lg transform hover:-translate-y-1" data-id="element-231">
          QUERO SENTIR MEU CORPO MAIS LEVE
        </a>
      </div>
    </section>;
}